var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55556 7C1.55556 3.99312 3.99312 1.55556 7 1.55556C10.0069 1.55556 12.4444 3.99312 12.4444 7C12.4444 10.0069 10.0069 12.4444 7 12.4444C3.99312 12.4444 1.55556 10.0069 1.55556 7ZM7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM9.50545 9.50543C9.20171 9.80917 8.70925 9.80917 8.40551 9.50543L7.00003 8.09994L5.59454 9.50543C5.2908 9.80917 4.79834 9.80917 4.4946 9.50543C4.19086 9.20169 4.19086 8.70923 4.4946 8.40548L5.90008 7L4.4946 5.59452C4.19086 5.29077 4.19086 4.79831 4.4946 4.49457C4.79834 4.19083 5.2908 4.19083 5.59454 4.49457L7.00003 5.90006L8.40551 4.49457C8.70925 4.19083 9.20171 4.19083 9.50545 4.49457C9.8092 4.79831 9.8092 5.29078 9.50545 5.59452L8.09997 7L9.50545 8.40548C9.8092 8.70923 9.80919 9.20169 9.50545 9.50543Z",
    fill: "#FF3030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageError);
export default __webpack_public_path__ + "static/media/message-error.1f06f0e917b9d584edc7a728907f1a13.svg";
export { ForwardRef as ReactComponent };